import React from 'react';
import { defineMessages } from 'react-intl';

import StaticSearch from 'Components/StaticSearch/StaticSearch';
import { fetchXboxGames } from 'Redux/ducks/algolia-calls';

const messages = defineMessages({
  title: {
    id: 'xbox-games.title',
    defaultMessage: 'Xbox Games',
  },
  fullTitle: {
    id: 'xbox-games.seotitle',
    defaultMessage: 'Xbox Games | Microsoft Xbox Game Keys',
  },
  desc: {
    id: 'xbox-games.seodesc',
    defaultMessage: 'Xbox games offer a thrilling array of adventures and experiences for both PC and console gamers, making it a beloved choice for many. Dive into the action-packed world of Gears of War, where you\'ll join Marcus Fenix and his squad in epic battles against the Locust Horde.For those seeking creativity and endless exploration, Minecraft is a must- play, inviting players to build, explore, and survive in blocky, pixelated worlds.If soaring through the skies is your passion, Microsoft Flight Simulator delivers stunningly realistic flight experiences, allowing you to pilot various aircraft across the globe.Halo, with its iconic Master Chief, offers a legendary sci- fi saga filled with intense combat and deep lore, captivating fans for over two decades.Racing enthusiasts can get their adrenaline pumping with the Forza series, providing unparalleled racing realism and a vast collection of cars and tracks.Whether you\'re a newcomer or a longtime fan, the Xbox game selection promises endless entertainment and adventure.',
  },
});

export default function XboxGames() {
  return (<StaticSearch
    showSortAndFilters
    updateHits={fetchXboxGames}
    seoBlurb={messages.desc}
    url="xbox"
    cardSizeLg={4}
    {...messages}
  />);
}
